import { apiRequest } from './client'

export const referenceApi = {
    getTable: (table) => apiRequest(`/reference?table=${encodeURIComponent(table)}`),

    getAudience: (buildingId) => apiRequest(`/audience/${encodeURIComponent(buildingId)}`),

    createRow: (table, data) =>
        apiRequest(`/reference/${encodeURIComponent(table)}`, {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        }),

    updateRow: (table, id, data) =>
        apiRequest(`/reference/${encodeURIComponent(table)}/${encodeURIComponent(id)}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data),
        }),

    deleteRow: (path) => apiRequest(path, { method: 'DELETE' }),
}
